module.exports = __webpack_public_path__ + "static/img/tabela.a55cd55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/agua-coco/tabela.png
// module id = 7GUr
// module chunks = 0